// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"e_0q","popupBlock":"e_1q"};